export enum PaymentMethodsEnum {
  Cash = 'cash',
  InStoreCard = 'in_store_card',
  Online = 'online',
}

export enum DietaryAttributeEnum {
  Vegetarian = 'vegetarian',
  Vegan = 'vegan',
  Halal = 'halal',
  GlutenFree = 'gluten_free',
  DairyFree = 'dairy_free',
  Spicy = 'spicy',
}

export enum DeliveryProviderEnum {
  UberDrive = 'uber_drive',
  WoltDrive = 'wolt_drive',
  FirstDelivery = 'first_delivery',
}

export enum SidebarSectionEnum {
  RestaurantInfo = 'restaurant_info',
  OrderMethodInfo = 'order_method_info',
  PromotedProducts = 'promoted_products',
  PaymentMethods = 'payment_methods',
  DietaryInfo = 'dietary_info',
  Catering = 'catering',
  ImportantNotes = 'important_notes',
  Reservations = 'reservations',
}
